import "lodash";
import { ICONS_COLOR_MAPPING as n } from "./index.es2359.js";
function c({
  color: t,
  outline: e,
  size: i = 18
}) {
  const o = t === "outline" && e ? n[e] : n["default-gray"], r = t && t !== "outline" ? n[t] : void 0, u = t === "blue" ? n.white : o;
  return {
    outline: o,
    fill: r,
    innerElementFill: u,
    size: i
  };
}
function g(t) {
  const { outline: e, size: i } = c(t);
  return {
    outline: e,
    fill: n.gray,
    size: i
  };
}
export {
  g as getCategoryIconProps,
  c as getMainIconProps
};
//# sourceMappingURL=index.es2361.js.map
